// extracted by mini-css-extract-plugin
export default {"mainContainer":"Chip_mainContainer__ghNsj","text":"Chip_text__4Rto8"};